import React from "react";
import "./Navbar.css";
// import About from "./About";
// import Projects from "./Projects";
// import Contact from "./Contact";
// import Work from "./Work";
import { Link, Element, scroller } from "react-scroll";
function Navbar() {
  const handleScroll = (to) => {
    scroller.scrollTo(to, {
      smooth: true,
      duration: 500,
    });
  };
  return (
    <nav className="  navbar-heading navbar navbar-expand-sm bg-body-tertiary text-secondary ">
      <div className="container-fluid">
        <a className="navbar-brand p-4 " href="#">
          <b className="display-6 text-center fw-bold">
            Amrit Anand <br /> Portfolio
          </b>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarNavAltMarkup">
          <div className="navbar-nav navigationOptions">
            <a className="nav-link active" aria-current="page" href="#">
              Home
            </a>
            <a
              className="nav-link active"
              href="#"
              smooth={true}
              duration={500}
              onClick={() => handleScroll("about")}
            >
              About
            </a>
            <a
              className="nav-link active"
              href="#"
              smooth={true}
              duration={500}
              onClick={() => handleScroll("Experience")}
            >
              Work
            </a>
            <a
              className="nav-link active"
              href="#"
              smooth={true}
              duration={500}
              onClick={() => handleScroll("Projects")}
            >
              Projects
            </a>
            <a
              className="nav-link active"
              href="#"
              smooth={true}
              duration={500}
              onClick={() => handleScroll("Contact")}
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
